import { useSyncExternalStore } from "react";

/** Desktop shell breakpoint — keep in sync with the "Desktop (≥1024px)" block in index.css. */
export const DESKTOP_QUERY = "(min-width: 1024px)";

/** Live result of a CSS media query (re-renders when it flips). */
export function useMediaQuery(query) {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    },
    () => window.matchMedia(query).matches,
    () => false
  );
}

/** True when the desktop shell (sidebar, tables, split panes, shortcuts) is active. */
export function useIsDesktop() {
  return useMediaQuery(DESKTOP_QUERY);
}

export default useMediaQuery;
